import { FormatServerName } from '@/utils/helpers.js'

export default {
  computed: {
    allTransactionsCount () {
      return (
        this.$store?.state?.transactions?.transactions?.page ||
        this.$store?.state?.transactions?.transactions?.attributes
          ?.statusCount ||
        {}
      )
    },
    totalCount () {
      return (
        this.$store?.state?.transactions?.transactions?.attributes
          ?.statusCount || {}
      )
    },
    showHistoryTransactions () {
      return (
        this.payload.type !== this.$transactionType.TRANSFER ||
        this.payload.status === this.$STATUS.COMPLETED ||
        this.payload.status === this.$STATUS.CANCELLED ||
        this.payload.status === this.$STATUS.HISTORY
      )
    },
    showOngoingTransactions () {
      return (
        this.payload.status === this.$STATUS.ONGOING ||
        this.payload.type !== this.$transactionType.TRANSFER ||
        this.payload.status === this.$STATUS.PENDING
      )
    },
    transactionCategories () {
      return [
        {
          name: 'All Transactions',
          isActive: this.activeCategory === 'All Transactions',
          status:
            this.payload.type === this.$transactionType.TRANSFER
              ? this.activeTab
              : '',
          count:
            this.allTransactionsCount.totalCount ||
            this.allTransactionsCount.total_count,
          isDisplayed: true
        },
        {
          name: this.$STATUS.PENDING,
          isActive: this.activeCategory === this.$STATUS.PENDING,
          status: this.$STATUS.PENDING,
          count: this.totalCount.pending,
          isDisplayed: this.showOngoingTransactions
        },
        {
          name: this.$STATUS.CANCELLED,
          isActive: this.activeCategory === this.$STATUS.CANCELLED,
          status: this.$STATUS.CANCELLED,
          count: this.totalCount.cancelled,
          isDisplayed: this.showHistoryTransactions
        },
        {
          name: this.$STATUS.COMPLETED,
          isActive: this.activeCategory === this.$STATUS.COMPLETED,
          status: this.$STATUS.COMPLETED,
          count: this.totalCount.completed,
          isDisplayed: this.showHistoryTransactions
        }
      ]
    }
  },
  methods: {
    rateIncreased (transaction) {
      const rateChange =
        !!transaction.transferredAmount &&
        Math.abs(transaction.transferredAmount - transaction.amount) > 0
      return rateChange
    },
    formatStatusName (name) {
      let formattedName
      switch (name) {
        case this.$STATUS.AWAITING_BUSINESS_APPROVAL:
          formattedName = this.$STATUS.AWAITING_APPROVAL
          break
        case this.$STATUS.DISAPPROVED:
          formattedName = this.$STATUS.CANCELLED
          break
        default:
          formattedName = name
      }
      return FormatServerName(formattedName)
    },
    formatPayoutStatus (val) {
      let formattedName
      switch (val) {
        case this.$STATUS.AWAITING_BUSINESS_APPROVAL:
          formattedName = this.$STATUS.AWAITING_APPROVAL
          break
        case this.$STATUS.DISAPPROVED:
          formattedName = this.$STATUS.TERMINATED
          break
        default:
          formattedName = val
      }
      return FormatServerName(formattedName)
    },
    setCategoryStatus (category) {
      this.activeCategory = category.name
      this.payload.status = category.status
      this.getTransactions()
    },
    getTransactions () {
      const vm = this
      this.isLoading = true
      this.$store
        .dispatch('transactions/getTransactions', this.payload)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
          const err = error.response
            ? error?.response?.data?.error?.publicMessage
            : error
          this.$notify({
            title: this.httpErrorMessage.customMessage,
            message: err || '',
            type: 'error'
          })
        })
    }
  }
}
